import { Grid } from '@material-ui/core';
import {
  CreditCardBorrowerDocumentationRequired,
  DocumentationRequiredType,
  OnboardingDetailsRole,
  PaymentMethodType,
} from '@nemuru-eng/js-api-client';

import { DocumentationRequiredFiles } from '@/components/modules/Documentation/components/DocumentationRequiredFiles/DocumentationRequiredFiles';
import { DocumentationMode } from '@/components/modules/Documentation/types/DocumentationMode';
import { Text } from '@/components/shared/components/Text';
import { CreditCardBorrowerOnboardingDetails } from '@/config/types';

interface DocumentationProps {
  mode: DocumentationMode;
  paymentMethodType: PaymentMethodType;
  documentation: CreditCardBorrowerDocumentationRequired;
  onboardingDetails: CreditCardBorrowerOnboardingDetails;
}

export const BorrowerDocumentation = ({
  mode,
  paymentMethodType,
  documentation,
  onboardingDetails,
}: DocumentationProps) => {
  if (!onboardingDetails.documentId) {
    return null;
  }

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} lg={6}>
        <DocumentationRequiredFiles
          selectedDocumentationCardParams={{
            documentationRequiredType: DocumentationRequiredType.BORROWER,
            iconName: 'person',
            labelText: <Text tId={OnboardingDetailsRole.BORROWER} />,
            labelIdentifier: `${onboardingDetails.documentId.fullName.firstName} ${onboardingDetails.documentId.fullName.lastName}`,
          }}
          selectedDocumentationRequired={documentation}
          selectedDocumentationRequiredType={DocumentationRequiredType.BORROWER}
          paymentMethodId={documentation.paymentMethodId}
          paymentMethodType={paymentMethodType}
          borrowerId={documentation.borrowerId}
          mode={mode}
        />
      </Grid>
    </Grid>
  );
};
